import React from 'react'
import BaseIcon from 'react-icon-base'
import { EColors } from 'app/constants/colors'

const Twitter = props => (
  <BaseIcon width="16" height="13" viewBox="0 0 16 13" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill={EColors.GREY} fillRule="evenodd">
      <path
        d="M15.899 2.035c-.389.595-.908 1.126-1.556 1.593v.383c0 2.231-.816 4.255-2.447 6.072-1.632 1.817-3.798 2.725-6.5 2.725A8.765 8.765 0 0 1 .6 11.406c.346.042.594.064.746.064a6.163 6.163 0 0 0 3.89-1.34 3.19 3.19 0 0 1-1.816-.62 2.922 2.922 0 0 1-1.102-1.515c.26.043.454.064.583.064.217 0 .497-.042.843-.127a3.178 3.178 0 0 1-1.799-1.068 2.909 2.909 0 0 1-.73-1.96v-.032c.476.255.952.382 1.427.382-.93-.595-1.394-1.456-1.394-2.582 0-.531.14-1.041.422-1.53 1.664 2.019 3.814 3.092 6.45 3.22-.043-.15-.065-.383-.065-.702 0-.871.303-1.604.908-2.2.605-.594 1.35-.892 2.237-.892.886 0 1.642.33 2.269.989.648-.107 1.318-.362 2.01-.765-.217.743-.681 1.317-1.394 1.72a5.425 5.425 0 0 0 1.815-.477z"
        fill={EColors.GREY}
        fillRule="evenodd"
      />
    </g>
  </BaseIcon>
)

export default Twitter
